import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {getClasses} from '../../helpers/mergeStylesHelper'
import Lk from '../lk/Lk'
import LkHeader from '../lk/LkHeader'
import LkHeaderAppend from '../lk/LkHeaderAppend'
import LkBody from '../lk/LkBody'
import EntityList from '../EntityList'
import {ReactComponent as BasketIcon} from '../../assets/icons/basket.svg'
import {colors} from '../../styles/colors'


const styles = {
  Root: {},
  CheckBoxText: {
    color: colors.black
  },
  BodyBottom: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30
  },
  LeftButtonToolbar: {
    background: colors.blue
  },
  BasketButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer'
  },
  BasketIcon: {
    '& path': {
      stroke: colors.red,
      fill: colors.white
    }
  }
}
const useStyles = makeStyles(styles)

export default function LkOperatorTaksoparkaTravelLists(props) {
  const classes = getClasses(props.classes, useStyles(props), styles)

  const tableData = [
    {
      driver: 'Колесников И.П.',
      date_pt: '2020.09.20/22:53',
      departure_allowed: 'Да',
      auto: 'Ниссан Альмера С014НН199',
      delete: 'id'
    },
    {
      driver: 'Колесников И.П.',
      date_pt: '2020.09.20/22:53',
      departure_allowed: 'Да',
      auto: 'Ниссан Альмера С014НН199',
      delete: 'id'
    },
    {
      driver: 'Колесников И.П.',
      date_pt: '2020.09.20/22:53',
      departure_allowed: 'Да',
      auto: 'Ниссан Альмера С014НН199',
      delete: 'id'
    },
    {
      driver: 'Колесников И.П.',
      date_pt: '2020.09.20/22:53',
      departure_allowed: 'Да',
      auto: 'Ниссан Альмера С014НН199',
      delete: 'id'
    },
    {
      driver: 'Колесников И.П.',
      date_pt: '2020.09.20/22:53',
      departure_allowed: 'Да',
      auto: 'Ниссан Альмера С014НН199',
      delete: 'id'
    },
  ]

  return (
    <Lk classes={classes}>
      <LkHeader title={'оператор таксопарка'} append={
        <LkHeaderAppend
          title='Личный кабинет'
          backLink={'/some'}
        />
      } />

      <LkBody activeTab={'travel-list'} type={'operator-taksoparka'}>
        <EntityList
          topToolbarSearchWidth={600}
          data={tableData}
          toolbarButtonText={'Добавить ПЛ'}
          toolbarLeftButtonClassName={classes.LeftButtonToolbar}
          columns={[
            {title: 'Водитель', field: 'driver', align: 'center'},
            {title: 'Дата/время выдачи ПТ', field: 'date_pt', align: 'center'},
            {title: 'Выезд разрешен', field: 'departure_allowed', align: 'center'},
            {title: 'Автомобиль', field: 'auto', align: 'center'},
            {
              title: 'Удалить запись',
              field: 'delete',
              align: 'center',
              render: () => (
                <button className={classes.BasketButton}>
                  <BasketIcon className={classes.BasketIcon} />
                </button>
              )
            },
          ]}
        />
      </LkBody>
    </Lk>
  )
}